// Phải import đầu tiên trong main.js: chunk lazy-load và CSS chunk lấy URL từ đây.
// Script/link ban đầu trong index.html do entrypoint.sh thêm prefix.
import {BASE_PATH} from '@/utils/base-path'

// eslint-disable-next-line no-undef
__webpack_public_path__ = BASE_PATH
